// Penalty Record — penalties awarded vs against, both teams (Phase 3 → M2 wave 4).
//
// Thin wrapper over the shared <StatPairBars> primitive (second consumer). Same
// shape as Scored & Conceded; only the data source + stat labels differ. Data
// now comes from app-api via `useWidgetData` (was the `getPenaltyRecordData`
// legacyData getter); the shared shaper + delegated DOM are unchanged.
// Fixture-first; timeline + rate from the context (controls reshape client-side,
// no refetch).

import { shapePenaltyRecord } from "@bento/shared";
import { useWidgetData } from "../../data/useWidgetData.js";
import { useFixtureKey } from "../../data/useFixtureKey.js";
import StatPairBars from "./StatPairBars.js";
import WidgetSkeleton from "./WidgetSkeleton.js";
import WidgetError from "./WidgetError.js";

export interface PenaltyRecordProps {
  fixture: string;
  /** Timeline toggle: "5" | "10" | "Season"; defaults to "5". */
  timeline?: string | null;
  /** Rate toggle: "Per Game" | "Total"; defaults to "Per Game". */
  rate?: string | null;
}

export default function PenaltyRecord({
  fixture,
  timeline,
  rate,
}: PenaltyRecordProps) {
  const parts = (fixture || "Arsenal v Everton").split(" v ");
  const home = (parts[0] ?? "").trim();
  const away = (parts[1] ?? "").trim();
  const { data, isPending, isError, refetch } = useWidgetData(
    "penalty-record",
    useFixtureKey(fixture)
  );

  if (isPending) return <WidgetSkeleton />;
  if (isError) return <WidgetError onRetry={refetch} />;

  const view = shapePenaltyRecord(
    data ?? {},
    home,
    away,
    timeline || "5",
    rate === "Total"
  );

  if (!view) {
    return (
      <div className="data-wrapper top-align">
        <div className="module-empty">No data</div>
      </div>
    );
  }
  return <StatPairBars fixture={fixture} {...view} />;
}
